// components/AI_Chat/SuggestedQuestions.tsx
import { motion } from "framer-motion";
import React from "react";

interface Question {
  id: string;
  text: string;
  emoji?: string;
  label?: string;
}

interface SuggestedQuestionsProps {
  questions: Question[];
  onSelect: (text: string) => void;
}

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const containerVariants = {
  hidden: { opacity: 0, y: 14 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, staggerChildren: 0.09 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.32 } },
};

const SuggestedQuestions = ({ questions, onSelect }: SuggestedQuestionsProps) => (
  <motion.div
    initial="hidden"
    animate="visible"
    variants={containerVariants}
    className="suggested-questions-modern"
  >
    <div className="questions-grid">
      {questions.map((q, idx) => (
        <motion.button
          key={q.id}
          variants={!isMobile ? itemVariants : undefined}
          whileHover={!isMobile ? { scale: 1.02 } : {}}
          whileTap={{ scale: 0.97 }}
          transition={{ delay: idx * 0.04 }}
          className="suggest-btn-modern"
          onClick={() => onSelect(q.text)}
        >
          {/*{q.emoji && <span className="suggest-icon">{q.emoji}</span>}*/}
          {q.label && <span className="suggest-label">{q.label}</span>}
          <span className="text">{q.text}</span>
          <span className="arrow-icon">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </motion.button>
      ))}
    </div>
  </motion.div>
);

export default SuggestedQuestions;
